import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { INotification, INotificationsByDateRange } from "notification/model"
import { getNotificationsByDateRange, loadNotifications } from "notification/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { NotificationItem } from "./NotificationItem"

interface INotificationListProps {
  allNotifications: INotification[]
  isLoading: boolean
  hasLoadingError: boolean
}

export const NotificationListFn = React.memo(
  ({ allNotifications, isLoading, hasLoadingError }: INotificationListProps): JSX.Element => {
    // triggered on first render only
    React.useEffect(() => {
      loadNotifications()
    }, [])
    const notificationsByDateRange = getNotificationsByDateRange(allNotifications)
    const ranges: Array<keyof INotificationsByDateRange> = (
      Object.keys(notificationsByDateRange) as Array<keyof INotificationsByDateRange>
    ).filter(r => notificationsByDateRange[r].length > 0)
    return (
      <FlexBox vertical fullHeight fullWidth jc="start">
        {ranges.length === 0 ? (
          <Typography color="textPrimary" fontSize=".9rem" sx={{ m: "1rem" }}>
            {translate("notification.empty")}
          </Typography>
        ) : (
          ranges.map(r => {
            const rangeNotifications = notificationsByDateRange[r]
            return (
              <FlexBox ai="start" vertical fullWidth key={r} id={`notification-range-${r}`}>
                <Typography color="textPrimary" fontSize=".85rem" fontWeight="500" sx={{ p: ".5rem", ml: "1rem" }}>
                  {translate(`notification.${r}`)}
                </Typography>
                {rangeNotifications.map(n => (
                  <NotificationItem notification={n} key={n.id} />
                ))}
              </FlexBox>
            )
          })
        )}
      </FlexBox>
    )
  }
)

export const NotificationList = connect(
  (state: IRootState): INotificationListProps => ({
    allNotifications: state.notification.notifications,
    isLoading: state.notification.isLoadingNewNotification,
    hasLoadingError: state.notification.hasLoadingNewNotificationError
  })
)(NotificationListFn)
